import Input from '../../Common/ui/input'
import SelectInput from '../../Common/ui/selectInput'
import { Box, Dialog, DialogActions, DialogContent, DialogTitle, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography, styled, Tooltip } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import * as RiskTypes from '../../Entities/RiskTypes'
import { Button } from '../../Common/ui/button'
import { IoAdd } from 'react-icons/io5'
import Heatmap from 'react-heatmap-grid'
import DateInput from '../../Common/ui/dateInput'
import { RiDeleteBin5Line } from 'react-icons/ri'
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress'
import { cn } from '../../lib/utils'
import * as Endpoints from '../../Entities/EndPoints'
import { useGovernanceStore } from 'src/Containers/Onboarding/Store/GovernanceStore'
import { useSettingsStore } from 'src/Containers/SettingsContainer/Store/Store'
import Axios from 'src/Axios'

// const Mitigation = ({ formData, setformData, riskScore, setRiskScore, actionTableData, setActionTableData }) => {
const Mitigation = ({ AllFormData, setAllFormData }) => {
    const { register, formState: { errors }, control } = useForm()
    const { t } = useTranslation()
    const [ open, setOpen ] = useState(false)
    const [ selectedBox, setSelectedBox ] = useState(null)
    const [ heatMapSelection, setheatMapSelection ] = useState(false)
    const [ measures, setMeasures ] = useState([])
    const [ departments, setDepartments ] = useState([])
    const percentageValue = AllFormData?.taskListResponse?.map((data) => Number(data.percentage)).reduce((a, b) => a + b, 0)

    const { configurationData, getConfigurationBasedOrganization } = useSettingsStore()
    const orgId = localStorage.getItem('orgId')
    useEffect(() => {
        getConfigurationBasedOrganization(orgId)
    }, [])
    useEffect(() => {
        if (configurationData.length > 0) {
            const data = configurationData?.filter(element => element.kindId === 5)
            const heatmap = data?.find(element => element.values === 1)?.subtitleName
            setheatMapSelection(heatmap === '5x5 Heat Map')
        }
    }, [configurationData])

    const onValueChange = (e, name) => {
        if (name === 'resolutionDate') {
            setAllFormData({ ...AllFormData, taskResponse: { ...AllFormData?.taskResponse, [name]: e } })
        } else {
            setAllFormData({ ...AllFormData, taskResponse: { ...AllFormData?.taskResponse, [name]: e.target.value } })
        }
    }

    const onMitigationValueChange = (e, name) => {
        if (name === 'measuresId') {
            setAllFormData({ ...AllFormData, mitigation: { ...AllFormData?.mitigation, [name]: e } })
        } else {
            setAllFormData({ ...AllFormData, mitigation: { ...AllFormData?.mitigation, [name]: e.target.value } })
        }
    }

    const handleActionTableValueChange = (e, name, ind) => {
        setAllFormData({
            ...AllFormData,
            taskListResponse: AllFormData?.taskListResponse?.map((data, index) => {
                if (index === ind) {
                    if (name === 'department' || name === 'startDate' || name === 'endDate') {
                        return { ...data, [name]: e }
                    } else {
                        return { ...data, [name]: e.target.value }
                    }
                } else {
                    return data
                }
            })
        })
    }

    const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
        height: 10,
        [`&.${linearProgressClasses.colorPrimary}`]: {
            backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800]
        },
        [`& .${linearProgressClasses.bar}`]: {
            backgroundColor: 'hsl(var(--primary))'
        }
    }))

    const handleRemoveTaskItem = (ind) => {
        setAllFormData({
            ...AllFormData,
            taskListResponse: AllFormData?.taskListResponse?.filter((filterData, index) => ind !== index)
        })
    }

    const handleAddTaskItem = () => {
        setAllFormData({
            ...AllFormData,
            taskListResponse: [ ...AllFormData?.taskListResponse, { name: '', startDate: '', endDate: '', assignee: '', department: '', percentage: '' }]
        })
    }

    useEffect(() => {
        if (AllFormData?.taskListResponse?.length === 0) {
            setAllFormData({
                ...AllFormData,
                taskListResponse: [
                    {
                        name: '',
                        startDate: '',
                        endDate: '',
                        assignee: '',
                        department: '',
                        percentage: ''
                    }
                ]
            })
        }
    }, [AllFormData?.taskListResponse])

    const handleBoxClick = (x, y) => {
        const riskScore = RiskTypes.RISK_SCROING_DATA[y][x]?.value
        const impact = x > 0 ? RiskTypes.RISK_SCROING_DATA[y][0]?.value : riskScore
        const probability = y < RiskTypes.RISK_SCROING_DATA.length - 1 ? RiskTypes.RISK_SCROING_DATA[RiskTypes.RISK_SCROING_DATA.length - 1][x]?.value : riskScore

        setAllFormData({
            ...AllFormData,
            impact: `${impact}(${RiskTypes.yLabels[RiskTypes.IMPACT_VALUE.indexOf(impact)]})`,
            probability: `${probability}(${RiskTypes.xLabels[RiskTypes.PROBABILITY_VALUE.indexOf(probability)]})`,
            riskScore: `${riskScore}(${(riskScore === RiskTypes.RISK_SCORE_ONE || riskScore === RiskTypes.RISK_SCORE_TWO) ? RiskTypes.RISK_LEVEL_CONTROLLED : (riskScore === RiskTypes.RISK_SCORE_THREE || riskScore === RiskTypes.RISK_SCORE_FOUR || riskScore === RiskTypes.RISK_SCORE_FIVE || riskScore === RiskTypes.RISK_SCORE_SIX) ? RiskTypes.RISK_LEVEL_LOW : (riskScore === RiskTypes.RISK_SCORE_EIGHT || riskScore === RiskTypes.RISK_SCORE_NINE) ? RiskTypes.RISK_LEVEL_MEDIUM : (riskScore === RiskTypes.RISK_SCORE_TEN || riskScore === RiskTypes.RISK_SCORE_TWELVE || riskScore === RiskTypes.RISK_SCORE_FIFTEEN || riskScore === RiskTypes.RISK_SCORE_SIXTEEN) ? RiskTypes.RISK_LEVEL_HIGH : (riskScore === RiskTypes.RISK_SCORE_TWENTY || riskScore === RiskTypes.RISK_SCORE_TWENTY_FIVE) && RiskTypes.RISK_LEVEL_EXTREME})`
        })
    }

    const handleThreeCrossBoxClick = (x, y) => {
        const riskScore = RiskTypes.RISK_SCROING_DATA_THREE_CROSS[y][x]?.value
        const impact = x > 0 ? RiskTypes.RISK_SCROING_DATA_THREE_CROSS[y][0]?.value : riskScore
        const probability = y < RiskTypes.RISK_SCROING_DATA_THREE_CROSS.length - 1 ? RiskTypes.RISK_SCROING_DATA_THREE_CROSS[RiskTypes.RISK_SCROING_DATA_THREE_CROSS.length - 1][x]?.value : riskScore

        setAllFormData({
            ...AllFormData,
            impact: `${impact}(${RiskTypes.Y_LABLES_THREE_CROSS[RiskTypes.IMPACT_VALUE_THREE_CROSS.indexOf(impact)]})`,
            probability: `${probability}(${RiskTypes.X_LABLES_THREE_CROSS[RiskTypes.PROBABILITY_VALUE_THREE_CROSS.indexOf(probability)]})`,
            riskScore: `${riskScore}(${(riskScore === RiskTypes.RISK_SCORE_ONE || riskScore === RiskTypes.RISK_SCORE_TWO) ? RiskTypes.RISK_LEVEL_LOW : (riskScore === RiskTypes.RISK_SCORE_THREE || riskScore === RiskTypes.RISK_SCORE_FOUR) ? RiskTypes.RISK_LEVEL_MEDIUM : (riskScore === RiskTypes.RISK_SCORE_SIX || riskScore === RiskTypes.RISK_SCORE_NINE) && RiskTypes.RISK_LEVEL_EXTREME})`
        })
    }

    const handleClose = () => {
        setOpen(false)
    }
    const instance = Axios.getInstance()

    const getAllMeasures = async () => {
        try {
            const response = await instance.get(Endpoints.API_ENDPOINT + '/masterController/GetAllMeasures')
            return response.data
        } catch (error) {
            console.error('Error fetching risk events:', error)
            throw error
        }
    }
    const { getDepOrganizations, allDepartments } = useGovernanceStore()
    useEffect(() => {
        const fetchRiskTypes = async () => {
            try {
                const types = await getAllMeasures()
                setMeasures(types)
            } catch (error) {
                console.error('Error fetching risk measures:', error)
            }
            try {
                getDepOrganizations(orgId)
            } catch (error) {
                console.error('Error fetching risk departments:', error)
            }
        }
        fetchRiskTypes()
    }, [])
    useEffect(() => {
        if (allDepartments.length > 0) {
            setDepartments(allDepartments)
        }
    }, [allDepartments])
    return (
        <Typography>
            <Box sx={{ py: 4, display: 'flex', alignItems: 'center' }}>
                <p className='risk-content-title' style={{ margin: 0 }}>{t('Mitigation Plan')}</p>
                <div style={{ margin: '0px 20px 0px 20px', flex: 1, borderBottom: '3px solid hsl(var(--primary-foreground))' }}></div>
            </Box>
            <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={4} >
                <Box gridColumn="span 3">
                    <SelectInput label={t('Measures')} required rules={{ required: 'This field is Required' }} control={control} errors={errors} name="measuresId" placeholder="Select Measures" onValueChange={onMitigationValueChange} value={AllFormData?.mitigation?.measuresId} options={measures.map(type => ({ value: type.name, label: type.name }))} />
                </Box>
                <Box gridColumn="span 6">
                    <Input errors={errors} control={control} required rules={{ required: 'This field is Required' }} name='mitigationDescription' label={t('Description')} register={register} placeholder="Enter Description" type="text" value={AllFormData?.mitigation?.mitigationDescription} onValueChange={onMitigationValueChange} />
                </Box>
                <Box gridColumn="span 3">
                    <Input errors={errors} control={control} required rules={{ required: 'This field is Required' }} name='mitigationBudget' label={t('Mitigation Budget')} register={register} placeholder="Enter Mitigation Budget" type="text" value={AllFormData?.mitigation?.mitigationBudget} onValueChange={onMitigationValueChange} />
                </Box>
                <Box gridColumn="span 3">
                    <Input errors={errors} control={control} required rules={{ required: 'This field is Required' }} name='availableAmount' label={t('Available Amount')} register={register} placeholder="Enter Available Amount" type="text" value={AllFormData?.mitigation?.availableAmount} onValueChange={onMitigationValueChange} />
                </Box>
            </Box>
            <Box sx={{ py: 4, display: 'flex', alignItems: 'center' }}>
                <p className='risk-content-title' style={{ margin: 0 }}>{t('Risk Scoring')}</p>
                <div style={{ margin: '0px 20px 0px 20px', flex: 1, borderBottom: '3px solid hsl(var(--primary-foreground))' }}></div>
            </Box>
            <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={4}>
                <Box gridColumn="span 3">
                    <Button variant="outline" onClick={() => { setOpen(true) }} className="m-0">
                        <span className="flex items-center" style={{ fontWeight: 'bold' }}>
                            <IoAdd className="mr-2" size={15} /> {t('Score')}
                        </span>
                    </Button>
                </Box>
                <Box gridColumn="span 3" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }} >
                    <p style={{ color: 'hsl(var(--primary))', fontWeight: 'bold', paddingRight: '10px' }} >{t('Impact')}</p>
                    :
                    <p style={{ paddingLeft: '10px' }} >{AllFormData?.impact || 0}</p>
                </Box>
                <Box gridColumn="span 3" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }} >
                    <p style={{ color: 'hsl(var(--primary))', fontWeight: 'bold', paddingRight: '10px' }} >{t('Probability')}</p>
                    :
                    <p style={{ paddingLeft: '10px' }} >{AllFormData?.probability || 0}</p>
                </Box>
                <Box gridColumn="span 3" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }} >
                    <p style={{ color: 'hsl(var(--primary))', fontWeight: 'bold', paddingRight: '10px' }} >{t('Risk Score')}</p>
                    :
                    <p style={{ paddingLeft: '10px' }} >{AllFormData?.riskScore || 0}</p>
                </Box>
                <Box gridColumn="span 6" >
                    <Input errors={errors} control={control} required rules={{ required: 'This field is Required' }} name='remarks' label={t('Remarks')} register={register} placeholder="Enter Remarks" type="text" value={AllFormData?.taskResponse?.remarks} onValueChange={onValueChange} />
                </Box>
            </Box>
            <Box sx={{ py: 4, display: 'flex', alignItems: 'center' }}>
                <p className='risk-content-title' style={{ margin: 0 }}>{t('Task List')}</p>
                <div style={{ margin: '0px 20px 0px 20px', flex: 1, borderBottom: '3px solid hsl(var(--primary-foreground))' }}></div>
            </Box>
            <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={4}>
                <Box gridColumn="span 3">
                    <div style={{ marginBottom: '2%' }}>
                        <DateInput value={AllFormData?.taskResponse?.resolutionDate} name='resolutionDate' register={register} onValueChange={onValueChange} label={t('Resolution Date')} required />
                    </div>
                </Box>
                <Box gridColumn="span 4" className='w-full flex flex-col justify-center' >
                    <div className='flex flex-row justify-between'>
                        <label className={cn('grc-label block mb-1')}>{t('Task Progress')}</label>
                        <label className={cn('grc-label block mb-1')}>{percentageValue}%</label>
                    </div>
                    <BorderLinearProgress variant="determinate" className='w-full' value={percentageValue} />
                </Box>
                <Box gridColumn="span 12" >
                    <TableContainer style={{ borderRadius: '0px' }} component={Paper}>
                        <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                            <TableHead>
                                <TableRow>
                                    <TableCell style={{ border: '1px solid hsl(var(--border))' }} align='center'>S.No</TableCell>
                                    <TableCell style={{ border: '1px solid hsl(var(--border))' }} align="center">Task</TableCell>
                                    <TableCell style={{ border: '1px solid hsl(var(--border))' }} align="center">Start Date</TableCell>
                                    <TableCell style={{ border: '1px solid hsl(var(--border))' }} align="center">End Date</TableCell>
                                    <TableCell style={{ border: '1px solid hsl(var(--border))' }} align="center">Department</TableCell>
                                    <TableCell style={{ border: '1px solid hsl(var(--border))' }} align="center">Assignee</TableCell>
                                    <TableCell style={{ border: '1px solid hsl(var(--border))' }} align="center">%</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {AllFormData?.taskListResponse?.map((row, ind) => (
                                    <TableRow key={row.name} >
                                        <TableCell style={{ padding: '0px', border: '1px solid hsl(var(--border)) ' }} align="center">{ind + 1}</TableCell>
                                        <TableCell style={{ padding: '0px', border: '1px solid hsl(var(--border))' }} align='center'>
                                            <Input className='shadow shadow-none ring-[0px] focus-visible:ring-[0px]' control={control} name='name' type="text" value={row?.name} onValueChange={(e, name) => handleActionTableValueChange(e, name, ind)} />
                                        </TableCell>
                                        <TableCell style={{ padding: '0px', border: '1px solid hsl(var(--border))' }} align="center">
                                            <DateInput className='shadow shadow-none border-none bg-transparent' value={row?.startDate} name='startDate' onValueChange={(e, name) => handleActionTableValueChange(e, name, ind)} />
                                        </TableCell>
                                        <TableCell style={{ padding: '0px', border: '1px solid hsl(var(--border))' }} align="center">
                                            <DateInput className='shadow shadow-none border-none bg-transparent' value={row?.endDate} name='endDate' onValueChange={(e, name) => handleActionTableValueChange(e, name, ind)} />
                                        </TableCell>
                                        <TableCell style={{ padding: '0px', border: '1px solid hsl(var(--border))' }} align="center">
                                            <SelectInput className='shadow shadow-none ring-[0px] focus-visible:ring-[0px]' control={control} errors={errors} name="department" placeholder="Select Department" onValueChange={(e, name) => handleActionTableValueChange(e, name, ind)} value={departments.map(type => ({ value: type.name, id: type.id, label: type.name }))?.find((dt) => row?.departmentId === dt.label)?.id} options={departments.map(type => ({ value: type.id, label: type.name }))}/>
                                        </TableCell>
                                        <TableCell style={{ padding: '0px', border: '1px solid hsl(var(--border))' }} align="center">
                                            <Input className='shadow shadow-none ring-[0px] focus-visible:ring-[0px]' control={control} name='assignee' type="text" value={row?.assignee} onValueChange={(e, name) => handleActionTableValueChange(e, name, ind)} />
                                        </TableCell>
                                        <TableCell style={{ padding: '0px', border: '1px solid hsl(var(--border))' }} align="center">
                                            <Input className='shadow shadow-none ring-[0px] focus-visible:ring-[0px]' control={control} name='percentage' type="number" value={row?.percentage} onValueChange={(e, name) => handleActionTableValueChange(e, name, ind)} />
                                        </TableCell>
                                        <TableCell style={{ padding: '0px', border: '1px solid hsl(var(--border))' }} align="center">
                                            <Tooltip title="Delete Task" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                                <RiDeleteBin5Line onClick={() => handleRemoveTaskItem(ind)} color='red' style={{ cursor: 'pointer', height: '20px', width: '20px' }} />
                                            </Tooltip>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <div className='flex flex-row justify-flex-end mt-1'>
                        <Button
                            // disabled={(addbuttonClick?.assignee === '' || addbuttonClick?.department === '' || addbuttonClick?.endDate === '' || addbuttonClick?.startDate === '' || addbuttonClick?.name === '' || addbuttonClick?.percentage === '')}
                            style={{ border: 'none' }} className='ml-auto items-right' onClick={handleAddTaskItem} variant="outline">{t('+ Add Task')}</Button>
                    </div>
                </Box>
            </Box>
            <Dialog
                maxWidth
                open={open}
                onClose={handleClose}
            >
                <Box sx={{ width: 1000 }} >
                    <DialogTitle sx={{ padding: '0px 10px 0px 10px', display: 'flex', alignItems: 'center', backgroundColor: 'hsl(var(--primary))', flexDirection: 'row', height: '40px', justifyContent: 'center' }}>
                        <div style={{ fontSize: '20px', fontWeight: 'bold', color: 'hsl(var(--accent))' }}>{t('Choose Risk Score')}</div>
                    </DialogTitle>
                    <DialogContent sx={{ width: '100%' }}>
                        <div style={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                            <div style={{ width: '40%', padding: '30px' }}>
                                <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                    <img src={'/Assets/Impact.svg'} style={{ height: '260px' }} alt="Impact" />
                                    <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                        {heatMapSelection
                                            ? <Heatmap
                                                xLabels={RiskTypes.xLabels?.map((dt, indedx) => <p key={indedx} style={{ fontSize: '10px' }} >{dt}</p>)}
                                                yLabels={RiskTypes.yLabels.map((dt, indedx) => <p key={indedx} style={{ fontSize: '10px', marginLeft: '-50px' }} >{dt}</p>)}
                                                xLabelsLocation={'bottom'}
                                                xLabelWidth={50}
                                                data={RiskTypes.RISK_SCROING_DATA}
                                                squares
                                                height={50}
                                                onClick={(x, y) => {
                                                    handleBoxClick(x, y)
                                                    setSelectedBox({ x, y })
                                                }}
                                                                                                          title={(value) => value?.value ?? ""}

                                                cellStyle={(background, value, min, max, data, x, y) => ({
                                                    fontSize: '12.5px',
                                                    backgroundColor: value?.color,
                                                    color: 'hsl(var(--accent))',
                                                    border: selectedBox && selectedBox.x === x && selectedBox.y === y ? '7px solid hsl(var(--score-box-highlight))' : 'none'
                                                })}
                                                cellRender={value => value && <div>{value.value}</div>}
                                            />
                                            : <Heatmap
                                                xLabels={RiskTypes.X_LABLES_THREE_CROSS?.map((dt, indedx) => <p key={indedx} style={{ fontSize: '10px' }} >{dt}</p>)}
                                                yLabels={RiskTypes.Y_LABLES_THREE_CROSS?.map((dt, indedx) => <p key={indedx} style={{ fontSize: '10px', marginLeft: '-50px' }} >{dt}</p>)}
                                                xLabelsLocation={'bottom'}
                                                xLabelWidth={50}
                                                data={RiskTypes.RISK_SCROING_DATA_THREE_CROSS}
                                                squares
                                                height={50}
                                                onClick={(x, y) => {
                                                    handleThreeCrossBoxClick(x, y)
                                                    setSelectedBox({ x, y })
                                                }}
                                                                                                          title={(value) => value?.value ?? ""}

                                                cellStyle={(background, value, min, max, data, x, y) => ({
                                                    fontSize: '12.5px',
                                                    backgroundColor: value?.color,
                                                    color: 'hsl(var(--accent))',
                                                    border: selectedBox && selectedBox.x === x && selectedBox.y === y ? '7px solid hsl(var(--accent))fff6e' : 'none'
                                                })}
                                                cellRender={value => value && <div>{value.value}</div>}
                                            />}
                                    </div>
                                </div>
                                <img src={'/Assets/Probability.svg'} style={{ paddingLeft: '60px', marginLeft: '21px', paddingTop: '20px', marginBottom: '-40px' }} alt="Impact" />
                            </div>
                            <div style={{ width: '60%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                                <Box display="grid" sx={{ p: 4 }} gridTemplateColumns="repeat(12, 1fr)" gap={4}>
                                    <Box gridColumn="span 6">
                                        <TextField label={t('Impact')} value={AllFormData?.impact || 0} InputProps={{ readOnly: true }} variant="standard" />
                                    </Box>
                                    <Box gridColumn="span 6">
                                        <TextField label={t('Probability')} value={AllFormData?.probability || 0} InputProps={{ readOnly: true }} variant="standard" />
                                    </Box>
                                    <Box gridColumn="span 6">
                                        <TextField label={t('Risk Score')} value={AllFormData?.riskScore || 0} InputProps={{ readOnly: true }} variant="standard" />
                                    </Box>
                                </Box>
                                <div style={{ margin: '0px 20px 0px 20px', flex: 1, borderBottom: '3px solid hsl(var(--primary-foreground))' }}></div>
                            </div>
                        </div>
                    </DialogContent>
                    <DialogActions style={{ width: '100%', display: 'flex', padding: '15px 30px 15px 30px', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                        {heatMapSelection
                            ? <div style={{ paddingLeft: '50px', display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', fontSize: '13px' }}>
                                <div style={{ marginRight: 10, fontSize: '12px' }}>Risk Level</div>
                                {RiskTypes.RISK_RATINNG?.map((data, ind) => {
                                    return (
                                        <div style={{ width: 65, border: '0.5px solid black', color: 'hsl(var(--accent))', textAlign: 'center', backgroundColor: data?.color, fontSize: '12px' }} key={ind} >{data?.title}</div>
                                    )
                                })}
                            </div>
                            : <div style={{ paddingLeft: '50px', display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', fontSize: '13px' }}>
                                <div style={{ marginRight: 10, fontSize: '12px' }}>Risk Level</div>
                                {RiskTypes.RISK_RATINNG_THREE_CROSS?.map((data, ind) => {
                                    return (
                                        <div style={{ width: 65, border: '0.5px solid black', color: 'hsl(var(--accent))', textAlign: 'center', backgroundColor: data?.color, fontSize: '12px' }} key={ind} >{data?.title}</div>
                                    )
                                })}
                            </div>}
                        <div>
                            <Button className='ml-auto' onClick={handleClose} variant="outline">{t('Cancel')}</Button>
                            <Button className={'mr-5 ml-4'} onClick={() => handleClose()}>{t('Submit')}</Button>
                        </div>
                    </DialogActions>
                </Box>
            </Dialog>
        </Typography>
    )
}

export default Mitigation
